import {
  tableCellPrimaryTextSx,
  tableCellSecondaryTextSx,
  tableCellTextBlockSx,
} from '@/ui/composites/table/cells/sharedCellContent';
import { Box, Text } from '@/ui/primitives';
import type { SemanticColorKey } from '@/theme/semanticTokens';
import type { ReactElement } from 'react';

type CoverageMetricTableCellProps = {
  primary: string;
  secondary: string;
  primaryColor?: SemanticColorKey;
};

export const CoverageMetricTableCell = ({
  primary,
  secondary,
  primaryColor = 'textPrimary',
}: CoverageMetricTableCellProps): ReactElement => (
  <Box sx={tableCellTextBlockSx}>
    <Text
      role="body"
      dataGridTypography="custom"
      color={primaryColor}
      sx={[tableCellPrimaryTextSx, { display: 'block' }]}
    >
      {primary}
    </Text>
    <Text
      role="body"
      dataGridTypography="custom"
      color="textSecondary"
      sx={[tableCellSecondaryTextSx, { display: 'block' }]}
    >
      {secondary}
    </Text>
  </Box>
);
